/* eslint-disable react/display-name */
import React from "react";

import PropTypes from "prop-types";

import { Router } from "@lululemon/ecom-core";

import { RadioButton } from "@lululemon/ui-library";

import { trackEvent } from "@lululemon/ecom-common/src/lib/analytics";

import styles from "./sort-accordion.module.scss";

import useParseContext from "../../hooks/useParseContext";

const setSort = ({
  text = "Featured",
  value,
  handleFilterSortChange = false,
  index,
  key,
}) => {
  // USED FOR SERP PAGES
  if (handleFilterSortChange) {
    // If key is present, it's being consumed by the new SERP
    if (typeof key !== "undefined") {
      return handleFilterSortChange({ label: text, key }, null, index);
    }
    // Old SERP
    return handleFilterSortChange(null, null, index);
  }

  trackEvent("cdp-sort-click", {
    page: {
      attributes: {
        appliedSort: text,
      },
    },
    version: "1.0",
  });
  return Router.push(value);
};

const SortAccordion = React.memo(
  ({
    facet: { text, value, isSelected, key },
    index,
    onSortMenuSelectClick,
  }) => {
    const {
      handleFilterSortChange: handleFilterSortChangeCDPCtx = null,
      selectedSortTitle,
    } = useParseContext();

    // The SearchContext HOC is not available in SERP, so useParseContext cannot be used for SERP.
    // isSelected is used exclusively for the SERP to override useParseContext values.
    const isChecked = selectedSortTitle === text || !!isSelected;
    const handleFilterSortChange =
      handleFilterSortChangeCDPCtx || onSortMenuSelectClick;

    return (
      <RadioButton
        id={text}
        data-testid="sort-option"
        name={text}
        className={`col-xs-12 ${styles.filterListItem}`}
        onClick={() =>
          setSort({
            text,
            value,
            handleFilterSortChange,
            index,
            key,
          })
        }
        checked={isChecked}
        classes={{
          labelContent: "lll-text-body-2",
        }}
      >
        {text}
      </RadioButton>
    );
  }
);

export default SortAccordion;

SortAccordion.defaultProps = {
  facet: {
    text: "Featured",
    value: "/",
  },
};

SortAccordion.propTypes = {
  facet: PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.string,
  }),
  index: PropTypes.number.isRequired,
};
